import { GenericResponseModel, LoginRequest } from "../dataModel/authModels";
import { AppyDocPostObj, DocumentRequestObj } from "../dataModel/documentModels";
import { ApiRoutes } from "./apiConfig/apiEdndpoints";
import { customAxios } from "./apiConfig/useExPressApi";

export const CarePlan = {
  getCP: (active: boolean) => {
    return customAxios.get<any, GenericResponseModel>(`${ApiRoutes.GET_CARE_PLAN}${active}`);
  },
  getTpSign: async (id: any) => {
    return customAxios.get(`${ApiRoutes.GET_CLIENT_TREATMENT_PLAN_SIGN}?treatmentPlanId=${id}`);
  },
  applySignature: (data: any): Promise<GenericResponseModel> => {
    return customAxios.post(`${ApiRoutes.APPLY_CLIENT_SIGNATURE}`, data);
  },
  getCarePlanReSignNotifications: () => {
    return customAxios.get<any, GenericResponseModel>(`${ApiRoutes.GET_CP_RESIGN_NOTIFICATION}`);
  }
}